import React from "react";


interface LogoLoginProps extends React.HTMLAttributes<HTMLElement>{

}

class LogoLogin extends React.Component<LogoLoginProps> {
  render() {
    return(
      <div {...this.props}>
        <img
          src={require('../../assets/Login.svg').default}
          alt="Logo - SVG"
          width="918px"
          height="327px"
        />
    </div>
    )
  }
}

export default LogoLogin;